export const columnsUserList = [
    {
      width: "5%",
      label: "S no",
      dataKey: "id",
      numeric: true,
      class: "d-flex justify-content-center"
    },
    {
      width: "10%",
      label: "Name",
      dataKey: "first_name"
    },
    {
      width: "10%",
      label: "Phone Number",
      dataKey: "phone_number",
    },
    {
      width: "15%",
      label: "Email ID",
      dataKey: "email"
    },
    {
        width: "15%",
        label: "City",
        dataKey: "city"
      },
    {
      width: "4%",
      label: "Active",
      dataKey: "is_active",
    }
  ];
  export const columnsShareReportData = [
    // {
    //   width: "2%",
    //   label: "",
    //   dataKey: "id_checked"
    // },
    {
      width: "1%",
      label: "S no",
      dataKey: "id",
      numeric: true,
      class: "d-flex justify-content-center"
    },
    {
      width: "3%",
      label: "Name",
      dataKey: "user_name"
    },
    {
      width: "3%",
      label: "Phone Number",
      dataKey: "phone_number",
    },
    {
      width: "3%",
      label: "Email ID",
      dataKey: "email"
    },
    {
        width: "3%",
        label: "City",
        dataKey: "user_city"
      },
      {
        width: "3%",
        label: "State",
        dataKey: "state"
      },
      {
        width: "5%",
        label: "Demat Account",
        dataKey: "demat_account"
      },
      {
        width: "8%",
        label: "Bank Details",
        dataKey: "bank_details"
      },
      {
        width: "3%",
        label: "Investment Type",
        dataKey: "investment_type"
      },
      {
        width: "2%",
        label: "Transaction Type",
        dataKey: "transaction_type"
      },
      {
        width: "3%",
        label: "No of Shares",
        dataKey: "no_of_shares"
      },
      {
        width: "3%",
        label: "Amount",
        dataKey: "share_amount"
      },
      {
        width: "3%",
        label: "Transaction Date",
        dataKey: "transaction_date"
      },
      {
        width: "3%",
        label: "Approved Date",
        dataKey: "approved_date"
      },
      {
        width: "3%",
        label: "Current Shares",
        dataKey: "current_shares"
      },
      {
        width: "3%",
        label: "Current Share Value",
        dataKey: "current_share_value"
      },
      
      
  ];

  export const columnsStoresList = [
    {
      width: "3%",
      label: "S no",
      dataKey: "id",
      numeric: true,
      class: "d-flex justify-content-center"
    },
    {
      width: "10%",
      label: "Store Name",
      dataKey: "Store_name"
    },
    {
      width: "7%",
      label: "Store Category",
      dataKey: "Store_Category"
    },
    {
      width: "10%",
      label: "City",
      dataKey: "city"
    },
    {
      width: "7%",
      label: "Phone Number",
      dataKey: "phone_number",
    },
    {
      width: "10%",
      label: "Email ID",
      dataKey: "email"
    },
    
    {
      width: "5%",
      label: "Status",
      dataKey: "is_activeStore",
    }
  ];

  export const columnsSharesList = [
    {
      width: "3%",
      label: "S no",
      dataKey: "id",
      numeric: true,
      class: "d-flex justify-content-center"
    },
    {
      width: "10%",
      label: "Share Name",
      dataKey: "Store_name"
    },
    {
      width: "7%",
      label: "Share Value",
      dataKey: "Share_Value"
    },
    {
      width: "5%",
      label: "Status",
      dataKey: "is_activeShare",
    }
  ];

  export const orderRequest = [
    {
      width: "3%",
      label: "S no",
      dataKey: "id",
      numeric: true,
      class: "d-flex justify-content-center"
    },
    {
      width: "7%",
      label: "Name",
      dataKey: "name"
    },
    {
      width: "7%",
      label: "Phone Number",
      dataKey: "phone_number",
    },
    {
      width: "5%",
      label: "Shares",
      dataKey: "share_count"
    },
    {
      width: "5%",
      label: "Amount",
      dataKey: "share_amount"
    },
    {
      width: "10%",
      label: "Message",
      dataKey: "order_message"
    },
    {
      width: "5%",
      label: "Status",
      dataKey: "order_status",
    }
  ];


  export const contactList = [
    {
      width: "2%",
      label: "S no",
      dataKey: "id",
      numeric: true,
      class: "d-flex justify-content-center"
    },
    {
      width: "5%",
      label: "Name",
      dataKey: "name"
    },
    {
      width: "5%",
      label: "Email Id",
      dataKey: "email"
    },
    {
      width: "5%",
      label: "Phone Number",
      dataKey: "phone_number",
    },
    {
      width: "7%",
      label: "State",
     dataKey: "state"
    },
    {
      width: "5%",
      label: "Message",
      dataKey: "order_message"
    },
    {
      width: "3%",
      label: "Detail",
      dataKey: "details",
    }
  ];
  export const serviceList = [
    {
      width: "3%",
      label: "S no",
      dataKey: "id",
      numeric: true,
      class: "d-flex justify-content-center"
    },
    {
      width: "12%",
      label: "Name",
      dataKey: "name"
    },
    {
      width: "4%",
      label: "Email Id",
      dataKey: "email"
    },
    {
      width: "7%",
      label: "Phone Number",
      dataKey: "phone_number",
    },
    {
      width: "8%",
      label: "Service",
     dataKey: "service"
    },
    {
      width: "5%",
      label: "amount",
     dataKey: "amount_invested"
    },
    {
      width: "8%",
      label: "State",
     dataKey: "state"
    },
    {
      width: "10%",
      label: "Message",
      dataKey: "order_message"
    },
    {
      width: "2%",
      label: "Detail",
      dataKey: "details",
    }
  ];

  export const mastercontactList = [
    {
      width: "3%",
      label: "S no",
      dataKey: "id",
      numeric: true,
      class: "d-flex justify-content-center"
    },
    {
      width: "10%",
      label: "Name",
      dataKey: "name"
    },
    {
      width: "7%",
      label: "Email Id",
      dataKey: "email"
    },
    {
      width: "7%",
      label: "Phone Number",
      dataKey: "phone_number",
    },
    {
      width: "2%",
      label: "Latitude",
     dataKey: "lat"
    },
    {
      width: "2%",
      label: "Longitude",
      dataKey: "lng"
    },
    {
      width: "2%",
      label: "Branch",
      dataKey: "branch",
    },
    {
      width: "15%",
      label: "Address",
      dataKey: "address",
    },
    {
      width: "2%",
      label: "Edit",
      dataKey: "contactListEdit",
    },
  ];

  export const masterHomeData = [
    {
      width: "3%",
      label: "S no",
      dataKey: "id",
      numeric: true,
      class: "d-flex justify-content-center"
    },
    {
      width: "5%",
      label: "Name",
      dataKey: "masterData_store_name"
    },
    {
      width: "7%",
      label: "Sub Heading",
      dataKey: "sub_heading"
    },
    {
      width: "10%",
      label: "Description",
      dataKey: "description"
    },
    {
      width: "2%",
      label: "Edit",
      dataKey: "homeDataEdit",
    },
  ];

  export const dynamicChangesHeader = [
    {
      width: "2%",
      label: "S no",
      dataKey: "id",
      numeric: true,
      class: "d-flex justify-content-center"
    },
    {
      width: "4%",
      label: "Key",
      dataKey: "key"
    },
    {
      width: "17%",
      label: "Value",
      dataKey: "value",
    },

    {
      width: "2%",
      label: "Edit",
      dataKey: "dynamicEdit",
    },
  ];

  export const timeLineHeader = [
    {
      width: "2%",
      label: "S no",
      dataKey: "id",
      numeric: true,
      class: "d-flex justify-content-center"
    },
    {
      width: "20%",
      label: "Description",
      dataKey: "description"
    },
    {
      width: "2%",
      label: "Year",
      dataKey: "year",
    },
    {
      width: "2%",
      label: "Edit",
      dataKey: "timeLineEdit",
    },

    
  ];

  export const seoHeader = [
    {
      width: "2%",
      label: "S no",
      dataKey: "id",
      numeric: true,
      class: "d-flex justify-content-center"
    },
    {
      width: "3%",
      label: "Page Name",
      dataKey: "pageName"
    },
    {
      width: "10%",
      label: "Title",
      dataKey: "title"
    },
    {
      width: "15%",
      label: "Description",
      dataKey: "description"
    },
    {
      width: "10%",
      label: "Keywords",
      dataKey: "keywords",
    },
    {
      width: "1%",
      label: "Edit",
      dataKey: "seoEdit",
    }
    
  ];
